<template>
  <el-container v-loading.fullscreen.lock="fullscreenLoading">
    <el-header>
      <div class="header-area"></div>
    </el-header>
    <el-container>
      <el-main>
        <div class="header-inner-area">
          <ul>
            <li>
              <router-link to="/0002">
                <img class="logo" src="../../assets/image/logo-new.png" alt="LOGO" />
              </router-link>
            </li>
            <li>
              <div class="company-title">{{ companytitle }}</div>
            </li>
            <li>
              <div class="company-title">{{ userName}}</div>
            </li>
            <ul class="NoticIconPosition">
              <!-- 2025/12/23 生成AIサービス連携 START -->
              <li v-if="ai_link_flag">
                <div class="elnet_ai" @click="handleAiButtonClick">
                  <el-link :underline="false">
                    <div class="aiIcon">
                      <div class="icon_elnet_ai_up" tabindex="0"></div>
                    </div>
                  </el-link>
                </div>
              </li>              
              <!-- 2025/12/23 生成AIサービス連携 END -->
              <li>
                <div class="notice" @click="UserNoticeClick">
                  <el-button>
                    <div class="speakerIcon">
                      <div class="ico_notice_up" tabindex="0"></div>
                      <span>{{ notice }}</span>
                    </div>
                  </el-button>
                </div>
              </li>
              <li>
                <div class="logout"  @click="logoutfunction">
                    <el-link :underline="false">
                      
                      <div class="logoutIcon" >
                        <div class="ico_logout_up" tabindex="0"></div>
                        <span>{{ logout }}</span>
                        </div>
                    </el-link>
                  </div>
                </li>
            </ul>            
          </ul>
        </div> 
      </el-main>      
    </el-container>
    <div>      
      <el-alert v-show="isNoticeExist" :title=adminNotice class="alertToast" :closable="false"></el-alert>
      <el-alert  v-show="isShowing" class="ql-editor adminAlertToaster" :closable="false">
        <code v-html="userNotice"></code>
      </el-alert>
    </div>
    
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import Common from '../../common/CommonFunc.js'
export default {
  data() {
    return {
      headerarea: "新聞・雑誌、WEB、TVクリッピング、情報収集",
      companytitle: "",
      userName: '',
      notice: "お知らせ",
      logout: "ログアウト",
      userNotice: '',
      adminNotice: '',
      isShowing:false,
      isNoticeExist:false,
      // 2025/12/23 生成AIサービス連携 START
      // 2026/06/15  生成AI連携商用版対応  START
      //ai_link_flag: false,
      // 2026/06/15  生成AI連携商用版対応  END
      fullscreenLoading: false,
      // 2025/12/23 生成AIサービス連携 END
    };
  },
  
  computed: {
    ...mapGetters("situation",["getUserNotice",
                              "getAdminUserAlertNotice"]),
    ...mapGetters("situation0001", ["getUserName",
                                  // 2025/12/23 生成AIサービス連携 START
                                  "getAiDisplayFlag",
                                  // 2025/12/23 生成AIサービス連携 END
                                  "getCompanyName"])
    // 2026/06/15  生成AI連携商用版対応  START
    ,ai_link_flag() {
      return this.getAiDisplayFlag;
    }
    // 2026/06/15  生成AI連携商用版対応  END
  },
  methods: {    
    // 2025/12/23 生成AIサービス連携 START
    handleAiButtonClick() {
      this.fullscreenLoading = true;
      this.$LogButtonEvent("mainComponent", "AiServiceButton");
      this.$LogMethodIN("mainComponent", "handleAiButtonClick");

      // Call backend to generate fresh JWT token
      // 2026/06/15  生成AI連携商用版対応  START
      const newWin = window.open('', '_blank');
      // 2026/06/15  生成AI連携商用版対応  END
      this.$store.dispatch('communication0001/getAiToken')
          .then(() => {
            setTimeout(() => {
              // 2026/06/15  生成AI連携商用版対応  START
              //window.open(Common.AI_SERVICE_URL, '_blank');
              const url = this.$store.getters['situation0001/getAiServiceUrl'];
              if (newWin && url) {
                newWin.location.href = url;
              } else if (newWin) {
                newWin.close();
              }
              // 2026/06/15  生成AI連携商用版対応  END
              this.fullscreenLoading = false;
              this.$LogMethodOut("mainComponent", "handleAiButtonClick");
            }, 1000);
          })
          .catch((error) => {
            console.error('Failed to get JWT token:', error);
            this.fullscreenLoading = false;
            // 2026/06/15  生成AI連携商用版対応  START
            if (newWin) newWin.close();
            // 2026/06/15  生成AI連携商用版対応  END
            this.$LogMethodOut("mainComponent", "handleAiButtonClick");
          });
    },
    // 2025/12/23 生成AIサービス連携 END
    UserNoticeClick(){
    //Api call for get the user notice
    this.$store.dispatch('communication/getUserNotice').then(() => {
      this.userNotice = this.getUserNotice
      this.isShowing ^= true;
    })

    },
    logoutfunction(){
      this.$LogButtonEvent("header","LogOut");
      this.$LogMethodIN("header","logoutfunction");      
      this.$store.dispatch('communication0001/logout');
      Common.Session.DestroySession_ForLogout(); 
      this.$LogMethodOut("header","logoutfunction");
    }
  },
  mounted() {
    //get the login user name from the session value
    this.userName = this.getUserName;
    //get the login user company name from the session value
    this.companytitle = this.getCompanyName;
    //Api call for get the user notice
    this.$store.dispatch('communication/getUserNotice').then(() => {
      this.userNotice = this.getUserNotice;
      if(this.userNotice != '' && this.userNotice != null)
      {
        this.isShowing ^= true;
      }
    });
    
    //Api call for get the el admin notice
    this.$store.dispatch('communication/getAdminUserNotice').then(() => {
      this.adminNotice = this.getAdminUserAlertNotice;
      if(this.adminNotice != null && this.adminNotice.trim() != ''){
        this.isNoticeExist = true;
      }
    })
        
  },
  // 2026/06/15  生成AI連携商用版対応  START
  //// 2025/12/23 生成AIサービス連携 START
  //created() {
  //  this.ai_link_flag = this.getAiDisplayFlag;
  //}
  // 2025/12/23 生成AIサービス連携 END
  // 2026/06/15  生成AI連携商用版対応  END
};
</script>
<style scoped>
@import "../../assets/css/style.css";
.el-col.el-col-3,
.el-col.el-col-6,
.el-col.el-col-9 {
  height: 50px;
}
.header-inner-area {
  width: 100%;
  margin: 0px auto;
  height: 50px;
}
.border-btm.el-row {
  height: 50px;
}

.header-area {
  width: 90%;
  margin: 0px auto;
  height: 20px;
    display: block;
}
.logout .el-link.el-link--default .el-link--inner span {
  font-size: 8pt;
  margin-bottom: 5px;
  display: block;
  margin-right: 16px;
  margin-left: 4px;
}
.el-main {
  padding: 0px !important;
  height: 50px;
  overflow: hidden !important;
}
.el-header {
  background-color: #242950;
  color: #333;
  text-align: center;
  height: 20px !important;
  padding: 0px !important;
  display: inline-table;
  margin: 0 auto;
  width: 100%;
}
.border-btm {
  margin: 0px !important;
}
.logo {
  width: 98px;
  margin-top: 11px;
  padding-left: 15px;
  height: 29px;
}
.company-title {
  font-size: 11.2pt;
  font-weight: bold;
  text-align: left;
  color: var(--primary);
  padding-left: 22px;
  padding-top: 25px;
}
.notice .el-link.el-link--default {
  margin-top: 22px !important;
  margin-bottom: -6px;
}
.notice {
  font-size: 8pt;
  color: var(--grayDark);
  text-align: left;
  padding-left: 16px;
}
.logoutIcon {
  height: 50px;
}
.speakerIcon,
.logoutIcon {
  display: flex;
}
.speakerIcon span {
  line-height: 2;
}

.ico_notice_up {
  background: url("../../assets/image/ico_notice_up.svg") no-repeat;
  height: 22px;
  width: 23.76px;
  margin-right: 4px;
}
.ico_notice_up:hover {
  background: url("../../assets/image/ico_notice_over.svg") no-repeat;
}
.ico_notice_up:focus {
  background: url("../../assets/image/ico_notice_down.svg") no-repeat;
  outline: none;
}
.ico_logout_up {
  background: url("../../assets/image/ico_logout_up.svg") no-repeat;
  height: 22px;
  width: 27.13px;
  margin-top: 21px;
  display: block;
}
.ico_logout_up:hover {
  background: url("../../assets/image/ico_logout_over.svg") no-repeat;
}
.ico_logout_up:focus {
  background: url("../../assets/image/ico_logout_down.svg") no-repeat;
  outline: none;
}
.notice span {
  vertical-align: sub;
  font-size: 8pt;
  color: var(--grayDark);
  margin-left: -1px;
}
.logout {
  font-size: 8pt;
  color: var(--grayDark);
  text-align: right;
}

.logout img {
  width: 20px;
  height: 18.52px;
  margin-bottom: 7px;
}
.logout span,
img {
  vertical-align: middle;
}
.logout .el-link.el-link--default {
  color: var(--grayDark) !important;
  height: 50px;
  display: block;
  line-height: 7;
}
.header-inner-area ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

.header-inner-area ul li {
  float: left;
}
.header-inner-area ul li:last-child {
    padding-left: 25px;
}

.notice .el-button {
  background: transparent;
  border: 0px;
  outline: none;
  margin: 0px !important;
  padding: 0px !important;
}
.speakerIcon {
  margin-top: 22px;
}

.NoticIconPosition {
  float: right;
}

.alertToast {
 background-color: var(--alertToast) !important;
   margin-top: 5px;
   border-radius: 5px;
   padding: 0px !important;
   text-align: left;
   color: white !important;
   margin-bottom: 5px !important;
   min-height: 30px;
   padding-left: 16px;
   width: 100%;
   margin: 0px auto;
}

.el-alert__content {
  padding: 0px 16px !important;
}
.logout__to {
    text-decoration: none;
    color: inherit;
}

.adminAlertToaster {
  background-color: #f4f4f5;
  margin-top: 5px;
  border-radius: 5px;
  padding: 0px !important;
  text-align: left;
  color: #000;
  margin-bottom: 5px !important;
  padding-left: 16px;
  width: 100%;
  margin: 0px auto;
}
.adminAlertToaster ::v-deep p {
 bottom: 0px !important;
 width:100%;
}
.adminAlertToaster ::v-deep .el-alert__content {
  width: 100%;
  padding-left: 20px;
}
/* 2025/12/23 生成AIサービス連携 START */
.icon_elnet_ai_up {
  background: url("../../assets/image/mc_button_elnetai.svg") no-repeat;
  width: 127px;
  height: 38px;
  background-size: 100% 100%;
  display: block;
}
.aiIcon {
  margin-top: 10px;
}
.elnet_ai {
  font-size: 8pt;
  color: var(--grayDark);
  text-align: left;
  padding-right: 10px;
}
/* 2025/12/23 生成AIサービス連携 END */

</style>
